var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidTier1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 80,
    viewBox: "0 0 94 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7126 78.1575L90.1965 59.4411C91.9426 58.5681 92.8167 56.8867 92.8188 55.2043V50.0381H0.179688V55.2043C0.181845 56.8867 1.05598 58.5681 2.80208 59.4411L39.286 78.1575C43.8268 80.4279 49.1717 80.4279 53.7126 78.1575Z",
    fill: "url(#paint0_linear_8129_25893)",
    fillOpacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.286 27.152C43.8268 24.8816 49.1717 24.8816 53.7126 27.152L90.1964 45.394C93.693 47.1423 93.693 52.132 90.1965 53.8802L53.7126 72.1222C49.1717 74.3926 43.8268 74.3926 39.286 72.1222L2.80208 53.8802C-0.69444 52.132 -0.694445 47.1423 2.80207 45.394L39.286 27.152Z",
    fill: "url(#paint1_linear_8129_25893)",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7139 72.1226L90.1978 53.8806C91.7894 53.0848 92.6565 51.6174 92.7992 50.0898C91.7537 52.4824 91.3202 52.6269 89.9984 53.4133L53.601 71.4212C52.5646 71.8855 49.7477 73.0922 46.3191 73.0922C42.8905 73.0922 40.2704 71.8855 39.3551 71.4212C27.663 65.564 3.92966 53.9776 2.80345 53.3776C1.67724 52.7775 0.683978 51.4248 0.328125 50.8235C0.644097 52.0744 1.4692 53.2135 2.80345 53.8806L39.2873 72.1226C43.8282 74.393 49.1731 74.393 53.7139 72.1226Z",
    fill: "url(#paint2_linear_8129_25893)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8129_25893)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4435 16.8997C44.4702 14.8863 49.2098 14.8863 53.2365 16.8996L85.5889 33.0759C88.6895 34.6262 88.6895 39.0508 85.5889 40.6011L53.2365 56.7774C49.2098 58.7907 44.4702 58.7907 40.4435 56.7774L8.09106 40.6011C4.99048 39.0508 4.99048 34.6262 8.09105 33.0759L40.4435 16.8997Z",
    fill: "url(#paint3_linear_8129_25893)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 36.8389V42.218C5.76754 43.7099 6.54268 45.2009 8.09105 45.9751L40.4435 62.572C44.4702 64.5854 49.2098 64.5854 53.2365 62.572L85.5889 45.9751C87.1373 45.2009 87.9124 43.7099 87.9143 42.218V36.848C87.9112 38.3387 87.1361 39.8279 85.5889 40.6015L53.2365 56.7777C49.2098 58.7911 44.4702 58.7911 40.4435 56.7777L8.09106 40.6015C6.54077 39.8263 5.76563 38.3326 5.76562 36.8389Z",
    fill: "url(#paint4_linear_8129_25893)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2388 56.777L85.5913 40.6008C87.0027 39.8951 87.7716 38.5939 87.8981 37.2393C86.971 39.3609 86.5866 39.489 85.4145 40.1863L53.1387 56.1551C52.2197 56.5668 49.7218 57.6368 46.6814 57.6368C43.641 57.6368 41.3176 56.5668 40.506 56.1551C30.1379 50.9611 9.09213 40.6867 8.09345 40.1547C7.09478 39.6226 6.21399 38.4231 5.89844 37.8898C6.17863 38.9991 6.9103 40.0092 8.09345 40.6008L40.4459 56.777C44.4726 58.7903 49.2122 58.7903 53.2388 56.777Z",
    fill: "url(#paint5_linear_8129_25893)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_8129_25893)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5282 8.80305C44.6566 7.23883 48.3389 7.23883 51.4673 8.80304L76.6029 21.3708C79.0118 22.5753 79.0118 26.0129 76.6029 27.2174L51.4673 39.7852C48.3389 41.3494 44.6566 41.3494 41.5282 39.7852L16.3926 27.2174C13.9837 26.0129 13.9837 22.5753 16.3926 21.3708L41.5282 8.80305Z",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_bi_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5859 24.2939V29.6117C14.5874 30.7708 15.1897 31.9292 16.3926 32.5307L41.5282 45.4253C44.6566 46.9895 48.3389 46.9895 51.4673 45.4253L76.6029 32.5307C77.8059 31.9292 78.4081 30.7708 78.4096 29.6117V24.301C78.4071 25.4592 77.8049 26.6162 76.6029 27.2172L51.4674 39.785C48.3389 41.3492 44.6566 41.3492 41.5282 39.785L16.3926 27.2172C15.1882 26.615 14.5859 25.4545 14.5859 24.2939Z",
    fill: "#E4E8F3",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4754 39.7849L76.6109 27.2171C77.7074 26.6689 78.3048 25.6579 78.4031 24.6055C77.6829 26.2538 77.3842 26.3534 76.4735 26.8951L51.3976 39.3017C50.6836 39.6216 48.7429 40.4529 46.3807 40.4529C44.0186 40.4529 42.2135 39.6216 41.5829 39.3017C33.5277 35.2663 17.1766 27.2839 16.4007 26.8705C15.6248 26.4572 14.9405 25.5252 14.6953 25.1109C14.913 25.9727 15.4815 26.7575 16.4007 27.2171L41.5362 39.7849C44.6646 41.3491 48.347 41.3491 51.4754 39.7849Z",
    fill: "url(#paint6_linear_8129_25893)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_8129_25893)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5618 1.73256C44.8877 0.569618 47.6254 0.569616 49.9512 1.73255L68.6386 11.0762C70.4296 11.9717 70.4296 14.5275 68.6386 15.423L49.9512 24.7666C47.6254 25.9296 44.8877 25.9296 42.5618 24.7666L23.8745 15.423C22.0835 14.5275 22.0835 11.9717 23.8745 11.0762L42.5618 1.73256Z",
    fill: "url(#paint7_linear_8129_25893)",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_bi_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5312 13.25V17.6444C22.5324 18.5062 22.9801 19.3674 23.8745 19.8146L42.5618 29.4013C44.8877 30.5642 47.6254 30.5642 49.9512 29.4013L68.6386 19.8146C69.533 19.3674 69.9807 18.5062 69.9818 17.6444V13.2553C69.98 14.1163 69.5323 14.9765 68.6386 15.4234L49.9512 24.767C47.6254 25.93 44.8877 25.93 42.5618 24.767L23.8745 15.4234C22.979 14.9756 22.5313 14.1128 22.5312 13.25Z",
    fill: "#E4E8F3",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_8129_25893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.954 24.7668L68.6414 15.4231C69.4566 15.0155 69.9008 14.2639 69.9738 13.4814C69.4384 14.7069 69.2163 14.781 68.5393 15.1837L49.8962 24.4075C49.3653 24.6454 47.9225 25.2634 46.1663 25.2634C44.4102 25.2634 43.0681 24.6454 42.5993 24.4075C36.6105 21.4074 24.4541 15.4728 23.8773 15.1654C23.3004 14.8581 22.7916 14.1652 22.6094 13.8572C22.7712 14.4979 23.1938 15.0814 23.8773 15.4231L42.5646 24.7668C44.8905 25.9297 47.6282 25.9297 49.954 24.7668Z",
    fill: "url(#paint8_linear_8129_25893)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8129_25893",
    x: 0.179688,
    y: 49.8009,
    width: 92.6387,
    height: 30.0595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.237197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.237197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_8129_25893",
    x: -10.9971,
    y: 14.2724,
    width: 114.992,
    height: 70.7295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.58839
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25893",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.237197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.237197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_8129_25893",
    x: -0.00717813,
    y: 49.7545,
    width: 93.1413,
    height: 24.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167652,
    result: "effect1_foregroundBlur_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8129_25893",
    x: 1.2721,
    y: 15.3896,
    width: 91.1355,
    height: 57.6794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.49353
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24676
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_8129_25893",
    x: -4.92056,
    y: 4.70346,
    width: 103.521,
    height: 64.2703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.34309
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25893",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.210337
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bi_8129_25893",
    x: -2.64786,
    y: 28.4254,
    width: 98.9754,
    height: 44.0701,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.20674
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25893",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.210337
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_8129_25893",
    x: 5.47776,
    y: 36.8186,
    width: 82.8413,
    height: 21.8892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.210337,
    result: "effect1_foregroundBlur_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_8129_25893",
    x: 10.5403,
    y: 7.62988,
    width: 71.9155,
    height: 47.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.04563
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.02281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_8129_25893",
    x: -5.41406,
    y: -12.3701,
    width: 103.824,
    height: 73.3286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bi_8129_25893",
    x: 8.04927,
    y: 17.7573,
    width: 76.8976,
    height: 35.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.26834
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25893",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.163417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_8129_25893",
    x: 14.3685,
    y: 24.2786,
    width: 64.3607,
    height: 17.0062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163417,
    result: "effect1_foregroundBlur_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_8129_25893",
    x: 18.5312,
    y: 0.860352,
    width: 55.4512,
    height: 37.4131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8129_25893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_8129_25893",
    x: 2.53125,
    y: -19.1396,
    width: 87.4512,
    height: 64.7783,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_bi_8129_25893",
    x: 17.6715,
    y: 8.39022,
    width: 57.1707,
    height: 26.743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.42989
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8129_25893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8129_25893",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.121495
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121495
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_8129_25893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_8129_25893",
    x: 22.3664,
    y: 13.2385,
    width: 47.8512,
    height: 12.6437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121495,
    result: "effect1_foregroundBlur_8129_25893"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8129_25893",
    x1: 92.8188,
    y1: 55.1551,
    x2: 0.179689,
    y2: 56.0101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC885A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8129_25893",
    x1: 92.8188,
    y1: 49.6371,
    x2: -1.13761,
    y2: 49.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB7359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8129_25893",
    x1: 0.328125,
    y1: 50.0898,
    x2: 92.7992,
    y2: 50.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8129_25893",
    x1: 89.4966,
    y1: 36.8385,
    x2: 5.76563,
    y2: 36.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF7F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8129_25893",
    x1: 87.9143,
    y1: 41.0945,
    x2: 5.76562,
    y2: 41.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8129_25893",
    x1: 5.89844,
    y1: 37.2393,
    x2: 87.8981,
    y2: 37.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8129_25893",
    x1: 14.6953,
    y1: 24.6055,
    x2: 78.4031,
    y2: 24.6055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8129_25893",
    x1: 57.5711,
    y1: 5.65464,
    x2: 32.31,
    y2: 18.7986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8129_25893",
    x1: 22.6094,
    y1: 13.4814,
    x2: 69.9738,
    y2: 13.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidTier1Icon);
export default __webpack_public_path__ + "static/media/bfid-tier_1-icon.d60cf316fbc5429afc62ba5b81caded0.svg";
export { ForwardRef as ReactComponent };